import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["panel"];

  connect() {
    this.instances = [];

    const triggerSearch = () => {
      if (typeof window.searchOrders === "function") {
        window.searchOrders();
      }
    };

    this.element.querySelectorAll("select[data-tom-select]").forEach((el) => {
      if (el.tomselect) return;
      const instance = new TomSelect(el, {
        allowEmptyOption: true,
        plugins: ["clear_button"],
        onChange: triggerSearch,
      });
      this.instances.push(instance);
    });

    this.nativeChangeHandler = triggerSearch;
    this.element
      .querySelectorAll("select:not([data-tom-select])")
      .forEach((el) => el.addEventListener("change", this.nativeChangeHandler));

    this.outsideClickHandler = (event) => {
      if (!this.hasPanelTarget) return;
      if (this.panelTarget.hidden) return;
      if (this.panelTarget.contains(event.target)) return;
      if (event.target.closest(".case-board__filters-toggle")) return;
      this.panelTarget.hidden = true;
    };
    document.addEventListener("click", this.outsideClickHandler);
  }

  disconnect() {
    this.instances.forEach((instance) => instance.destroy());
    this.instances = [];

    if (this.nativeChangeHandler) {
      this.element
        .querySelectorAll("select:not([data-tom-select])")
        .forEach((el) =>
          el.removeEventListener("change", this.nativeChangeHandler)
        );
    }

    if (this.outsideClickHandler) {
      document.removeEventListener("click", this.outsideClickHandler);
    }
  }

  togglePanel(event) {
    event.stopPropagation();
    if (!this.hasPanelTarget) return;
    this.panelTarget.hidden = !this.panelTarget.hidden;
  }
}
